import React, { PureComponent } from 'react'
import { Tab, Tabs, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { fleetsTab } from '../../../../constants/management/fleets'
import { dossierTypes as dossierTypesConstant, dossierTypesId as dossierTypeIdsConstant } from '../../../../constants/dossier/common/dossierTypes'
import { operationTabs } from '../../../../constants/management/operations'
import { dossierSubTypeId } from '../../../../constants/dossier/common/dossierSubType'
import { dossierStagesBySubtype } from '../../../../constants/dossier/common/dossierStages'
import { saleCodes } from '../../../../constants/dossier/common/fieldCodePermissions'
import { dossierSubTypes } from '../../../../constants/backendIds'
import { buttonsSidebar } from '../../../../constants/dossier/common/buttonsSidebar'
import * as fleetsUtils from '../../../../util/management/fleetsUtils'

import CancelReasonModal from '../../../../components/dossiers/common/CancelReasonModal'
import RejectCommentModal from '../../../../components/dossiers/common/RejectCommentModal'
import DataClientChargePage from '../../../../containers/management/fleets/data/DataClientChargePage'
import DossiersListFleetDetailsComponentPage from '../../../../containers/management/fleets/dossiers/DossiersListFleetDetailsComponentPage'
import PaperworkFleetListComponentPage from '../../../../containers/management/fleets/dossiers/PaperworkFleetListComponentPage'
import EconomicFleetModalPage from '../../../../containers/management/fleets/economic/EconomicFleetModalPage'
import DocumentsFleetModalPage from '../../../../containers/management/fleets/documents/DocumentsFleetModalPage'
import DeliveryFleetListComponentPage from '../../../../containers/management/fleets/data/DeliveryFleetListComponentPage'

import DataSalesFleetModalPage from '../../../../containers/management/fleets/auxModals/DataSalesFleetModalPage'
import DataContactFleetModalPage from '../../../../containers/management/fleets/auxModals/DataContactFleetModalPage'
import DataFinancingFleetModalPage from '../../../../containers/management/fleets/auxModals/DataFinancingFleetModalPage'
import DataDeliveryFleetModalPage from '../../../../containers/management/fleets/auxModals/DataDeliveryFleetModalPage'
import ServiceAddModalPage from '../../../../containers/dossiers/common/services/ServiceAddModalPage'
import DataOtherDataFleetModalPage from '../../../../containers/management/fleets/auxModals/DataOtherDataFleetModalPage'
import DataPaperWorkFleetModalPage from '../../../../containers/management/fleets/auxModals/DataPaperWorkFleetModalPage'
import AuditFleetModalPage from '../../../../containers/management/fleets/audits/AuditFleetModalPage'
import ConditionsListComponentPage from '../../../../containers/management/fleets/conditions/ConditionsListComponentPage'
import DossierHistoricalsFleetComponentPage from '../../../../containers/management/fleets/historicals/DossierHistoricalsFleetComponentPage'
import PurchaseFleetListComponentPage from '../../../../containers/management/fleets/relatedDossiers/PurchaseFleetListComponentPage'
import DataPurchasesFleetModalPage from '../../../../containers/management/fleets/auxModals/DataPurchasesFleetModalPage'

class FleetsTab extends PureComponent {
  constructor (props) {
    super()
    this.state = {
      tabActiveKey: 1,
      pendingTab: null,
      changeCheckAll: false,
      haveChanges: false,
      resetForms: 0,
      showCancelReasonModal: false,
      showRejectCommentModal: false,
      showServiceModal: false,
      subTypesAllowedToCreate: [],
      dossierList: [],
      actionId: null,
      dataId: null,
      dossierTypeSelected: dossierTypeIdsConstant.sales,
      dossierTypeSelectedString: dossierTypesConstant.sales,
      documentsAllSelected: true
    }
    this.listSubTypesWithDefaultEntity = [dossierSubTypes.service_pap, dossierSubTypes.deliveryPreparation]
    this.listSubTypesWithBlockedEntity = [dossierSubTypes.deliveryPreparation]
    this.listSubTypesWithOrderDateByDefault = [dossierSubTypes.service_pap]
    this.listSubTypesWithOrderDateTodayNoEditable = [dossierSubTypes.deliveryPreparation]
    this.listSubTypesWithMandatoryObservations = [dossierSubTypes.deliveryPreparation]
    this.listSubTypesWithRequiredDatesInvalids = [dossierSubTypes.deliveryPreparation]
  }

  componentDidMount () {
    if (this.props.fleetData?.fleet?.fleetId &&
      this.props.tabActiveKey &&
      this.props.tabActiveKey !== this.state.tabActiveKey) {
      this.doTabChange(this.props.tabActiveKey, true)
    }
  }

  componentDidUpdate (prevProps) {
  }

  openDocumentsModal (fleet, selectedDossiers, dossierTypeSelected) {
    this.props.actions.openDocumentFleetModal(this.props.fleetData.fleet, true, selectedDossiers.map(dossier => dossier.dossierId))
    this.setState({ tabActiveKey: fleetsTab.FLEETS_DOCUMENTS, dossierTypeSelected: dossierTypeSelected || this.state.dossierTypeSelected, dossierTypeSelectedString: dossierTypesConstant.sales })
    this.props.tabActiveKeyChange(fleetsTab.FLEETS_DOCUMENTS)
  }

  haveChanges (haveChanges) {
    this.setState({ haveChanges })
  }

  async launchAction (val, tabId, dossiers = null) {
    var found

    switch (tabId) {
      case operationTabs.DATA:
        found = this.props.dataActions.find(x => x.managementActionId === val)
        break
      case operationTabs.OPERATIONS:
        found = this.props.operationActions.find(x => x.managementActionId === val)
        break
      case operationTabs.DATA_PAPERWORK:
        found = this.props.dataPaperWorkActions.find(x => x.managementActionId === val)
        break
      case operationTabs.OPERATIONS_PAPERWORK:
        found = this.props.operationPaperWorkActions.find(x => x.managementActionId === val)
        break
      case operationTabs.DATA_PURCHASE:
        found = this.props.dataPurchaseActions.find(x => x.managementActionId === val)
        break
      case operationTabs.OPERATIONS_PURCHASE:
        found = this.props.operationPurchaseActions.find(x => x.managementActionId === val)
        break
    }

    this.setState({ actionId: null, dataId: null })
    this.props.actions.initializeOperationActionsCombo(null, null)
    if (found) {
      const selectedDossiers = dossiers || this.props.dossierFleetDetails.filter(dossier => dossier.checked)
      const extraValue = await this.getExtraValue(val, tabId, selectedDossiers, found)
      if (extraValue !== null) {
        this.executeFunctionByName(found.function, fleetsUtils, selectedDossiers, this.props, this.setState.bind(this), extraValue)
      } else {
        this.executeFunctionByName(found.function, fleetsUtils, selectedDossiers, this.props, this.setState.bind(this))
      }
    }
  }

  executeFunctionByName (functionName, context) {
    var args = Array.prototype.slice.call(arguments, 2)
    var namespaces = functionName.split('.')
    var func = namespaces.pop()
    for (var i = 0; i < namespaces.length; i++) {
      context = context[namespaces[i]]
    }
    return context[func].apply(context, args)
  }

  async getExtraValue (val, tabId, selectedDossiers, found) {
    switch (found.function) {
      case 'setDeliveryData':
        var deliveryFleetDetails = this.props.deliveryFleetDetails
        if (!this.props.deliveryFleetDetails || this.props.deliveryFleetDetails.length === 0) {
          deliveryFleetDetails = await new Promise((resolve, reject) => {
            this.props.actions.getDeliveriesDetailsFleet(this.props.fleetData.fleet.fleetId, resolve)
          })
        }
        return deliveryFleetDetails && deliveryFleetDetails.length > 0 && deliveryFleetDetails.some(delivery => delivery.dossierList.some(id => selectedDossiers.map(d => d.dossierId).includes(id)))

      default:
        return null
    }
  }

  checkStageForEconomicAnalysis (dossiersArray, dossierSubtypeId) {
    let dossiers = []

    dossiersArray.forEach(item => {
      if (dossierSubtypeId === dossierSubTypeId.venta_vn) {
        if (item.stageId < dossierStagesBySubtype.saleVn.documentation) {
          dossiers.push(item)
        }
      }
      if (dossierSubtypeId === dossierSubTypeId.venta_vo) {
        if (item.stageId < dossierStagesBySubtype.saleVo.documentation) {
          dossiers.push(item)
        }
      }
    })

    return dossiers
  }

  checkShowEconomicDossiers (dossiers) {
    let showEconomicDossiers = []
    dossiers.forEach(dossier => {
      if (dossier.showEconomic) {
        showEconomicDossiers.push(dossier)
      }
    })
    return showEconomicDossiers
  }

  openEconomicPlan (fleet, selectedDossiers) {
    if (selectedDossiers && selectedDossiers.length > 0) {
      let dossierShowEconomic = this.checkShowEconomicDossiers(selectedDossiers)
      if (dossierShowEconomic && dossierShowEconomic.length > 0) {
        let dossierStageEconomic = this.checkStageForEconomicAnalysis(dossierShowEconomic, fleet.dossierSubType)
        if (dossierStageEconomic && dossierStageEconomic.length > 0) {
          if (dossierStageEconomic.length < selectedDossiers.length) {
            this.props.actions.openModal('noAllEconomicDosiersOnFleet', () => { this.props.actions.openEconomicFleetModal(fleet, false, dossierStageEconomic) }, null, null, null, [{ id: '##NUM_OK##', value: dossierStageEconomic.length }, { id: '##NUM_TOTAL##', value: selectedDossiers.length }], null)
          } else {
            this.props.actions.openEconomicFleetModal(this.props.fleetData.fleet, false, dossierStageEconomic)
          }
          this.setState({ tabActiveKey: fleetsTab.FLEETS_ECONOMIC, dossierTypeSelectedString: dossierTypesConstant.sales })
          this.props.tabActiveKeyChange(fleetsTab.FLEETS_ECONOMIC)
        } else {
          this.props.actions.openModal('noEconomicStageDossiersOnFleet')
        }
      } else {
        this.props.actions.openModal('noEconomicDossiersOnFleet')
      }
    } else {
      this.props.actions.openModal('noDossiersOnFleet')
    }
  }

  openConditionsFleetComponent (selectedDossiers, callModal = false) {
    if (this.props.fleetData?.fleet?.fleetId) {
      if (!this.props.dossierFleetDetails || this.props.dossierFleetDetails.length === 0) {
        new Promise((resolve, reject) => {
          this.props.actions.getDossierDetailsFleet(this.props.fleetData.fleet.fleetId, resolve)
        }).then((response) => {
          this.props.actions.openConditionsFleetComponent(callModal ? selectedDossiers : selectedDossiers.map(dossier => dossier.dossierId))
          this.setState({ tabActiveKey: fleetsTab.FLEETS_CONDITIONS, dossierTypeSelectedString: dossierTypesConstant.sales })
          this.props.tabActiveKeyChange(fleetsTab.FLEETS_CONDITIONS)
        }).catch(() => { })
      } else {
        this.props.actions.openConditionsFleetComponent(callModal ? selectedDossiers : selectedDossiers.map(dossier => dossier.dossierId))
        this.setState({ tabActiveKey: fleetsTab.FLEETS_CONDITIONS, dossierTypeSelectedString: dossierTypesConstant.sales })
        this.props.tabActiveKeyChange(fleetsTab.FLEETS_CONDITIONS)
      }
    }
  }

  moveToModifyDocumentsSelection (dossierTypeSelected = dossierTypeIdsConstant.sales) {
    switch (dossierTypeSelected) {
      case dossierTypeIdsConstant.sales:
      case dossierTypeIdsConstant.paperwork:
        this.setState({ tabActiveKey: fleetsTab.FLEETS_DOSSIERS, dossierTypeSelectedString: dossierTypesConstant.sales })
        this.props.tabActiveKeyChange(fleetsTab.FLEETS_DOSSIERS)
        break
      case dossierTypeIdsConstant.purchase:
        this.setState({ tabActiveKey: fleetsTab.FLEETS_RELATED_DOSSIERS, dossierTypeSelectedString: dossierTypesConstant.purchase })
        this.props.tabActiveKeyChange(fleetsTab.FLEETS_RELATED_DOSSIERS)
        break
      default:
        this.setState({ tabActiveKey: fleetsTab.FLEETS_DOSSIERS, dossierTypeSelectedString: dossierTypesConstant.sales })
        this.props.tabActiveKeyChange(fleetsTab.FLEETS_DOSSIERS)
        break
    }
  }

  moveToModifyEconomicSelection () {
    this.onTabChange(fleetsTab.FLEETS_DOSSIERS)
  }

  onTabChange (tabActiveKey) {
    if (this.props.dirty || this.state.haveChanges) {
      this.setState({ pendingTab: tabActiveKey })
      this.props.actions.openModal('genericYesNoModal',
        this.confirmAction.bind(this),
        () => { },
        'MESSAGES.COMMON_HEADER_BUTTONS.SAVE_WARNING')
    } else {
      if (this.state.resetForms) {
        this.setState({ resetForms: false })
      }
      this.doTabChange(tabActiveKey)
    }
  }

  doTabChange (tabActiveKey, reMountComponent = false) {
    switch (parseInt(tabActiveKey, 10)) {
      case fleetsTab.FLEETS_ECONOMIC:
        if (!this.props.dossierFleetDetails || this.props.dossierFleetDetails.length === 0) {
          new Promise((resolve, reject) => {
            this.props.actions.getDossierDetailsFleet(this.props.fleetData.fleet.fleetId, resolve)
          }).then((response) => {
            this.openEconomicPlan(this.props.fleetData.fleet, response)
          }).catch(() => { })
        } else {
          this.openEconomicPlan(this.props.fleetData.fleet, this.props.dossierFleetDetails)
        }
        break
      case fleetsTab.FLEETS_DOCUMENTS:
        this.props.actions.openDocumentFleetModal(this.props.fleetData.fleet, true, [])
        this.setState({ tabActiveKey, dossierTypeSelectedString: dossierTypesConstant.sales })
        this.props.tabActiveKeyChange(tabActiveKey)
        break
      case fleetsTab.FLEETS_AUDITS:
        this.props.actions.showAuditFleetModal(true, this.props.fleetData.fleet)
        this.setState({ tabActiveKey, dossierTypeSelectedString: dossierTypesConstant.sales })
        this.props.tabActiveKeyChange(tabActiveKey)
        break
      case fleetsTab.FLEETS_CONDITIONS:
        if (!reMountComponent) {
          this.props.actions.openConditionsFleetComponent([])
        }
        this.setState({ tabActiveKey, dossierTypeSelectedString: dossierTypesConstant.sales })
        this.props.tabActiveKeyChange(tabActiveKey)
        break
      case fleetsTab.FLEETS_RELATED_DOSSIERS:
        this.setState({ tabActiveKey, dossierTypeSelectedString: dossierTypesConstant.purchase })
        this.props.tabActiveKeyChange(tabActiveKey)
        break
      default:
        this.setState({ tabActiveKey, dossierTypeSelectedString: dossierTypesConstant.sales })
        this.props.tabActiveKeyChange(tabActiveKey)
        break
    }
  }

  confirmAction () {
    if (this.props.dirty) {
      this.props.reset()
    }

    if (this.state.haveChanges) {
      this.setState(prev => ({
        haveChanges: false,
        resetForms: prev.resetForms + 1
      }))
    }

    this.doTabChange(this.state.pendingTab)
  }

  render () {
    const {
      t, change, combos, isReadOnly, formValues, dispatch, stopAsyncValidation, asyncValidateFunc, tKey, changeEntity, clientFleetPermissions, fleetData, fleetId
    } = this.props
    const tooltipFleetData = (<Tooltip id="tooltipFleetData" className="tooltip-buttons-header"><span >{t(`${tKey}TABS.FLEET_DATA`)}</span></Tooltip>)
    const tooltipFleetFiles = (<Tooltip id="tooltipFleetFiles" className="tooltip-buttons-header"><span >{t(`${tKey}TABS.FLEET_FILES`)}</span></Tooltip>)
    const tooltipFleetRelated = (<Tooltip id="tooltipFleetRelated" className="tooltip-buttons-header"><span >{t(`${tKey}TABS.FLEET_RELATED`)}</span></Tooltip>)
    const tooltipFleetHistorical = (<Tooltip id="tooltipFleetHistorical" className="tooltip-buttons-header"><span >{t(`${tKey}TABS.FLEET_HISTORICAL`)}</span></Tooltip>)
    const tooltipFleetEconomic = (<Tooltip id="tooltipFleetEconomic" className="tooltip-buttons-header"><span >{t(`${tKey}TABS.FLEET_ECONOMIC`)}</span></Tooltip>)
    const tooltipFleetDocuments = (<Tooltip id="tooltipFleetDocuments" className="tooltip-buttons-header"><span >{t(`${tKey}TABS.FLEET_DOCUMENTS`)}</span></Tooltip>)
    const tooltipFleetTimeLine = (<Tooltip id="tooltipFleetTimeLine" className="tooltip-buttons-header"><span >{t(`${tKey}TABS.FLEET_TIMELINE`)}</span></Tooltip>)
    const tooltipFleetComments = (<Tooltip id="tooltipFleetComments" className="tooltip-buttons-header"><span >{t(`${tKey}TABS.FLEET_COMMENTS`)}</span></Tooltip>)
    return (
      <>
        <Tabs id="fleetsTab" defaultActiveKey={fleetsTab.FLEETS_DATA} activeKey={this.state.tabActiveKey} onSelect={tabActiveKey => this.onTabChange(tabActiveKey)}>
          {
            <Tab eventKey={fleetsTab.FLEETS_DATA} title={<OverlayTrigger placement="bottom" overlay={tooltipFleetData} id="time_line"><i className="iDocIcon-description" /></OverlayTrigger>}>
              <DataClientChargePage
                t={t}
                tKey={tKey}
                isClientLoaded={true}
                fleetData={fleetData}
                fleetId={fleetId}
                combos={combos}
                changeEntity={changeEntity}
                dossierType={dossierTypesConstant.createNewFleetModal}
                readOnlyFields={isReadOnly || false}
                open={true}
                clientFleetPermissions={clientFleetPermissions}
                // disableDeleteButton={!this.props.create || isReadOnly}
                disableDeleteButton ={!this.props.fleetData.changeEntity}
                change={change}
                dispatch={dispatch}
                formValues={formValues}
                stopAsyncValidation={stopAsyncValidation}
                asyncValidateFunc={asyncValidateFunc}
                haveChanges={this.props.haveChanges}
                actions={this.props.actions}
                tabActiveKey={this.state.tabActiveKey}
              />
              <DeliveryFleetListComponentPage
                fleetData={fleetData}
                fleet={fleetData?.fleet}
                fleetId={fleetId}
                create={this.props.fleetData?.create}
                readOnlyFields={isReadOnly || false}
                tabActiveKey={this.state.tabActiveKey}
                haveChanges={this.props.haveChanges}
                actions={this.props.actions}
                executeFunctionByName={(functionName, context, ...args) => this.executeFunctionByName(functionName, context, ...args)}
              />
            </Tab>
          }
          {
            <Tab eventKey={fleetsTab.FLEETS_DOSSIERS} title={<OverlayTrigger placement="bottom" overlay={tooltipFleetFiles} id="time_line"><i className="ico-folder" /></OverlayTrigger>}>
              <DossiersListFleetDetailsComponentPage
                fleet={this.props.fleetData?.fleet}
                create={this.props.fleetData?.create}
                changeCheckAll={this.state.changeCheckAll}
                readOnlyFields={this.props.isReadOnly}
                tabActiveKey={this.state.tabActiveKey}
                fields={this.props.fields}
                fieldsConfiguration={this.props.fieldsConfiguration}
                haveChanges={this.props.haveChanges}
                actions={this.props.actions}
                openDocumentsModal={(fleet, selectedDossiers) => this.openDocumentsModal(fleet, selectedDossiers, dossierTypeIdsConstant.sales)}
                openEconomicPlan={(fleet, selectedDossiers) => this.openEconomicPlan(fleet, selectedDossiers)}
                launchAction={(val, tabId, dossiers) => { this.launchAction(val, tabId, dossiers); this.setState({ actionId: val }) }}
                documentsAllSelected={(val) => this.setState({ documentsAllSelected: val })}
                openConditionsFleetComponent={(selectedDossiers) => this.openConditionsFleetComponent(selectedDossiers)}
              />
              <PaperworkFleetListComponentPage
                fleet={this.props.fleetData?.fleet}
                create={this.props.fleetData?.create}
                readOnlyFields={this.props.isReadOnly}
                tabActiveKey={this.state.tabActiveKey}
                fieldsConfiguration={this.props.fieldsConfiguration}
                openDocumentsModal={(fleet, selectedDossiers) => this.openDocumentsModal(fleet, selectedDossiers, dossierTypeIdsConstant.paperwork)}
                launchAction={(val, tabId, dossiers) => { this.launchAction(val, tabId, dossiers); this.setState({ actionId: val }) }}
                haveChanges={this.props.haveChanges}
                actions={this.props.actions}
                documentsAllSelected={(val) => this.setState({ documentsAllSelected: val })}
              />
            </Tab>
          }
          {
            <Tab eventKey={fleetsTab.FLEETS_RELATED_DOSSIERS} title={<OverlayTrigger placement="bottom" overlay={tooltipFleetRelated} id="time_line"><i className="ico-relacion" /></OverlayTrigger>} disabled={fleetId === '-1'}>
              <PurchaseFleetListComponentPage
                fleet={this.props.fleetData?.fleet}
                create={this.props.fleetData?.create}
                readOnlyFields={this.props.isReadOnly}
                tabActiveKey={this.state.tabActiveKey}
                fieldsConfiguration={this.props.fieldsConfiguration}
                openDocumentsModal={(fleet, selectedDossiers) => this.openDocumentsModal(fleet, selectedDossiers, dossierTypeIdsConstant.purchase)}
                launchAction={(val, tabId, dossiers) => { this.launchAction(val, tabId, dossiers); this.setState({ actionId: val }) }}
                haveChanges={this.props.haveChanges}
                actions={this.props.actions}
                documentsAllSelected={(val) => this.setState({ documentsAllSelected: val })}
              />
            </Tab>
          }
          { this.props.dossierHistoricalFleetDetails && this.props.dossierHistoricalFleetDetails.length > 0 &&
            <Tab eventKey={fleetsTab.FLEETS_HISTORICALS} title={<OverlayTrigger placement="bottom" overlay={tooltipFleetHistorical} id="time_line"><i className="iDocIcon-archive" /></OverlayTrigger>} disabled={fleetId === '-1'}>
              <DossierHistoricalsFleetComponentPage
                fleet={this.props.fleetData?.fleet}
                create={this.props.fleetData?.create}
                tabActiveKey={this.state.tabActiveKey}
              />
            </Tab>
          }
          {
            <Tab eventKey={fleetsTab.FLEETS_ECONOMIC} title={<OverlayTrigger placement="bottom" overlay={tooltipFleetEconomic} id="time_line"><i className="ico-planteo-economico" /></OverlayTrigger>} disabled={fleetId === '-1'}>
              <EconomicFleetModalPage
                fieldsConfiguration={this.props.fieldsConfiguration}
                checkStageForEconomicAnalysis={this.checkStageForEconomicAnalysis}
                setHaveEconomicChanges={haveChanges => this.haveChanges(haveChanges)}
                haveEconomicChanges={this.state.haveChanges}
                resetForms={this.state.resetForms}
                moveToModifyEconomicSelection={() => this.moveToModifyEconomicSelection()}
                selectAll={() => this.openEconomicPlan(this.props.fleetData.fleet, this.props.dossierFleetDetails)}
              />
            </Tab>
          }
          {
            <Tab eventKey={fleetsTab.FLEETS_DOCUMENTS} title={<OverlayTrigger placement="bottom" overlay={tooltipFleetDocuments} id="time_line"><i className="ico-docs" /></OverlayTrigger>} disabled={fleetId === '-1'}>
              <DocumentsFleetModalPage
                tabActiveKey={this.state.tabActiveKey}
                fieldsConfiguration={this.props.fieldsConfiguration}
                moveToModifyDocumentsSelection={(dossierTypeSelected) => this.moveToModifyDocumentsSelection(dossierTypeSelected)}
                dossierFleetDetails={this.props.dossierFleetDetails}
                purchaseFleetDetails={this.props.purchaseFleetDetails}
                dossierTypeSelected={this.state.dossierTypeSelected}
                change={change}
                changeDossierTypeSelected={(val) => this.setState({ dossierTypeSelected: val })}
                allSelected={this.state.documentsAllSelected}
                documentsAllSelected={(val) => this.setState({ documentsAllSelected: val })}
              />
            </Tab>
          }
          {
            <Tab eventKey={fleetsTab.FLEETS_CONDITIONS} title={<OverlayTrigger placement="bottom" overlay={tooltipFleetTimeLine} id="time_line"><i className="iDocIcon-list-check-formalities" /></OverlayTrigger>} disabled={fleetId === '-1'}>
              <ConditionsListComponentPage
                tabActiveKey={this.state.tabActiveKey}
                fieldsConfiguration={this.props.fieldsConfiguration}
                moveToModifyConditionsSelection={() => this.moveToModifyDocumentsSelection()}
                actions={this.props.actions}
                dossierFleetDetails={this.props.dossierFleetDetails}
                change={change}
                openConditionsFleetComponent={(selectedDossiers) => this.openConditionsFleetComponent(selectedDossiers, true)}
              />
            </Tab>
          }
          {
            <Tab eventKey={fleetsTab.FLEETS_AUDITS} title={<OverlayTrigger placement="bottom" overlay={tooltipFleetComments} id="time_line"><i className="ico-actividad-expediente" /></OverlayTrigger>} disabled={fleetId === '-1'}>
              <AuditFleetModalPage
                fleet={this.props.fleetData?.fleet}
                tabActiveKey={this.state.tabActiveKey}
              />
            </Tab>
          }
        </Tabs>
        {this.state.showRejectCommentModal && <RejectCommentModal
          t={t}
          showModal={this.state.showRejectCommentModal}
          reasonCombo={this.props.combos.reasonCombo}
          dossierSubTypeId={this.props.fleetData.fleet.dossierSubType}
          actions={{
            rejectAction: (comment, resolve, reject) => {
              if (this.state.dossierTypeSelectedString === dossierTypesConstant.purchase) {
                this.props.actions.setOperateActionRejectPurchaseProcess(comment, this.props.purchaseFleetDetails.filter(dossier => dossier.checked), this.props.fleetData.fleet.fleetId, () => { this.setState({ showRejectCommentModal: false }) })
              } else {
                this.props.actions.setOperateActionRejectProcess(comment, this.props.dossierFleetDetails.filter(dossier => dossier.checked), this.props.fleetData.fleet.fleetId, () => { this.setState({ showRejectCommentModal: false }) })
              }
            },
            closeModal: () => this.setState({ showRejectCommentModal: false }),
            fetchReasons: this.props.actions.fetchReasons
          }}
          backDropStatic={true}
        />}
        <CancelReasonModal
          t={t}
          showModal={this.state.showCancelReasonModal}
          combos={this.props.combos.cancelCombo}
          type={this.state.dossierTypeSelectedString}
          actions={{
            rejectAction: (comment, resolve, reject) => {
              if (this.state.dossierTypeSelectedString === dossierTypesConstant.purchase) {
                this.props.actions.setOperateActionDeletePurchaseProcess(comment, this.props.purchaseFleetDetails.filter(dossier => dossier.checked), this.props.fleetData.fleet.fleetId, () => { })
              } else {
                this.props.actions.setOperateActionDeleteProcess(comment, this.props.dossierFleetDetails.filter(dossier => dossier.checked), this.props.fleetData.fleet.fleetId, () => { })
              }
              this.setState({ showCancelReasonModal: false })
            },
            closeModal: () => {
              this.setState({ showCancelReasonModal: false })
            },
            fetchCancelCombo: this.props.actions.fetchCancelCombo
          }}
        />
        <DataSalesFleetModalPage
          componentConfiguration={this.props.componentsModalConfiguration ? this.props.componentsModalConfiguration.componentsConfiguration.find(x => x.code === saleCodes.bsale) : null}
        />
        <DataFinancingFleetModalPage
          componentConfiguration={this.props.componentsModalConfiguration ? this.props.componentsModalConfiguration.componentsConfiguration.find(x => x.code === saleCodes.bsale) : null}
        />
        <DataContactFleetModalPage/>
        <DataPaperWorkFleetModalPage/>
        <DataDeliveryFleetModalPage
          componentConfiguration={this.props.componentsModalConfiguration ? this.props.componentsModalConfiguration.componentsConfiguration.find(x => x.code === saleCodes.bsale) : null}
        />
        <ServiceAddModalPage
          t={t}
          showModal={this.state.showServiceModal}
          ouId={this.state.dossierList.length > 0 ? this.state.dossierList[0].organizedUnitId : this.props.fleetData?.fleet?.organizedUnitId}
          subTypesAllowedToCreate={this.state.subTypesAllowedToCreate}
          dossierId={-1}
          datesNotValid={this.props.dossierServiceRelateds?.datesNotValid || []}
          actions={{
            openOrCloseAddServiceModal: () => fleetsUtils.openOrCloseServiceAddModal(false, this.props, this.setState.bind(this)),
            fetchDossierSubTypes: this.props.actions.fetchDossierSubTypes,
            fetchEntityFilterSubTypeCombo: this.props.actions.fetchEntityFilterSubTypeCombo,
            fetchEntitySubTypeCombo: this.props.actions.fetchEntitySubTypeCombo,
            saveSalesService: () => null,
            fetchDefaultEntity: this.props.actions.fetchDefaultEntity,
            fetchNotValidDatesService: this.props.actions.fetchNotValidDatesService,
            setOperateDataServiceFleetProcess: this.props.actions.setOperateDataServiceFleetProcess
          }}
          dossierConstriction={{
            listSubTypesWithOrderDateTodayNoEditable: this.listSubTypesWithOrderDateTodayNoEditable || [],
            listSubTypesWithDefaultEntity: this.listSubTypesWithDefaultEntity || [],
            listSubTypesWithBlockedEntity: this.listSubTypesWithBlockedEntity || [],
            listSubTypesWithRequiredDatesInvalids: this.listSubTypesWithRequiredDatesInvalids || [],
            listSubTypesWithOrderDateByDefault: this.listSubTypesWithOrderDateByDefault || [],
            listSubTypesWithMandatoryObservations: this.listSubTypesWithMandatoryObservations || []
          }}
          combos={this.props.combos}
          isFleet={true}
          fleet={this.props.fleetData?.fleet}
          dossierList={this.state.dossierList}
        />
        <DataOtherDataFleetModalPage
          componentConfiguration={this.props.componentsModalConfiguration ? this.props.componentsModalConfiguration.componentsConfiguration.find(x => x.code === saleCodes.bsale) : null}
        />
        <DataPurchasesFleetModalPage
          componentConfiguration={this.props.componentsModalConfiguration ? this.props.componentsModalConfiguration.componentsConfiguration.find(x => x.code === buttonsSidebar.bpurchase) : null}
        />
      </>
    )
  }
}
export default FleetsTab
